import { Box, Chip, Typography } from "@mui/material";
import { MembershipOption } from "../types";

interface MembershipOptionCardProps {
  option: MembershipOption;
  isSelected: boolean;
  onClick?: () => void;
}

export const MembershipOptionCard = ({
  option,
  isSelected,
  onClick,
}: MembershipOptionCardProps) => {
  const textColor = isSelected ? "white" : "textPrimary";
  const textSecondaryColor = isSelected ? "white" : "textSecondary";
  const hasBadge = option.supportHours == 8;

  return (
    <Box
      onClick={onClick}
      sx={(theme) => ({
        border: `1px solid ${
          isSelected ? theme.palette.primary.main : theme.palette.border
        }`,
        borderRadius: "16px",
        padding: "16px 20px",
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: isSelected ? theme.palette.primary.main : "white",
        gap: "16px",
        cursor: "pointer",
      })}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography variant="h4" color={textColor}>
          {option.name}
        </Typography>
        <Typography variant="body" color={textSecondaryColor}>
          {option.supportHours} hours of support a month
        </Typography>
        <Typography variant="body" color={textSecondaryColor}>
          {option.maxUsers} {option.maxUsers === 1 ? "account" : "accounts"}
        </Typography>
        {option.additionalFeatures && (
          <Box>
            {option.additionalFeatures.map((feature) => (
              <Typography
                variant="body"
                color={textSecondaryColor}
                key={feature}
              >
                {feature}
              </Typography>
            ))}
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "end",
          gap: "12px",
          justifyContent: hasBadge ? "start" : "center",
        }}
      >
        {hasBadge && (
          <Chip
            label="Most popular"
            variant={isSelected ? "tealDark" : "green"}
            size="small"
            sx={{ border: isSelected ? "1px solid white" : "initial" }}
          />
        )}

        <Box sx={{ display: "flex" }}>
          <Typography variant="h4" color={textColor}>
            ${option.amountCents / 100}
          </Typography>
          <Typography variant="body" color={textColor}>
            /mo
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
